export default {
  path: 'groups',
  name: 'FleetGroups',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/FleetGroupsView.vue')
}
